<template>
  <div>
    <!-- src="https://oa-statics.caihonggou.com/courseware_test/cocosKeJian/index.html" -->
    <iframe
      ref="lookIframe"
      :style="!$store.state.course.isShowHead?'position: fixed;left: 0;width: 100%;height: 100%;margin: 0;transform: none;':''"
      :src="`https://oa-statics.caihonggou.com/${courseType}/cocosKeJian/index.html`"
      class="main-scene"
      frameborder="0"
    />
  </div>
</template>

<script>
import mapUtils, { $form, $http, axiosRequest } from "@/utils";
import * as CourseListServer from "../../api/courseList";
import SharePassword from "./sharePassword.vue";
import Config from '../../config/app';

export default {
  name: "CoursePreview",
  components: {
    SharePassword,
  },
  data() {
    return {
      playload: {
        course_config: "",
        //         JSON.stringify(
        //   {
        //     home: [],
        //     warmup: [],
        //     learn: [],
        //     game: [],
        //     summary: [],
        //     celebrate: [],
        //   },
        // ),
        theme_config: "",
      },
    };
  },
  computed: {
    // 区分正式环境
    courseType() {
      let name = 'courseware_test';
      if (Config.isRelease) {
        name = 'courseware';
      }
      return name;
    },
  },
  created() {
    this.$nextTick(() => {
      // 如果是分享页面 对body重新排盘 -- 适配手机端
      if (!this.$store.state.course.isShowHead) {
        document.body.style.position = "fixed";
        document.body.style.left = 0;
        document.body.style.right = 0;
      }
    });

    // 如果参数code存在表示需要登录密码
    const { code } = this.$route.query;
    if (code) {
      this.$store.state.course.isShowHead = false;
    }
  },
  mounted() {
    console.log("CoursePreview");
    const _this = this;
    window.onmessage = function (e) {
      const { type, playload } = e.data;
      if (type === "getConfig") {
        _this.getAllResource(_this.$route.params.courseID, _this.$route.params.theme_id);
        // _this.getCourseConfig(_this.$route.params.courseID);
        // _this.getThemeConfig(_this.$route.params.theme_id);
      }
    };
  },
  destroyed() {
    window.onmessage = function () {};
  },
  methods: {
    // 显示动画
    handleShow() {
      this.isShowPwdPage = false;
      this.$store.state.course.isShowHead = false;
    },
    // 获取资源
    async getAllResource(id, theme_id) {
      const data = await CourseListServer.queryConfig({ id });
      if (data.json_config_original) {
        this.playload.course_config = data.json_config_original.replace(
                /.zip/g,
                "/index.html",
        );
      }
      const data1 = await CourseListServer.queryTheme({ theme_id });
      if (data1.json_config_original) {
        this.playload.theme_config = JSON.stringify(data1.json_config_original);
        console.log("发送信息到cocos", this.playload);
        this.playload.course_config && this.$refs.lookIframe.contentWindow.postMessage({ playload: this.playload, type: "getConfig" }, "*");
      }
    },
    // async getCourseConfig(id) {
    //   console.log("getCourseConfig--", id);
    //   const data = await $http
    //     .get(`/courseware_packet/${id}`);
    //     // .then((data) => {
    //
    //       if (data.json_config_original) {
    //         this.playload.course_config = data.json_config_original.replace(
    //           /.zip/g,
    //           "/index.html",
    //         );
    //       }
    //     // })
    //     // .catch((e) => {});
    // },
    //
    // async getThemeConfig(theme_id) {
    //   console.log(`getThemeConfig--${theme_id}`);
    //   // 获得皮肤配置
    //   const data = await $http.get(`/theme/${theme_id}`);
    //           // .then((data) => {
    //     if (data.json_config_original) {
    //       this.playload.theme_config = JSON.stringify(data.json_config_original);
    //       console.log("发送信息到cocos", this.playload);
    //       this.playload.course_config && this.$refs.lookIframe.contentWindow.postMessage({ playload: this.playload, type: "getConfig" }, "*");
    //     }
    //   // });
    // },
  },

};
</script>

<style>
.main-scene {
  transform: scale(0.7);
  width: 1920px;
  height: 1080px;
  margin-top: -150px;
}
</style>
